import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const X = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-x-icon lucide-x'
      >
        <path d='M18 6 6 18' />
        <path d='m6 6 12 12' />
      </svg>
    </SvgIcon>
  );
};

export default X;
